import React from "react";
/**
 * Allows the user to customize their signature:
 * - Template selection (Modern / Classic)
 * - Override individual profile fields (e.g., a different phone number)
 * - Add social links (LinkedIn, Twitter/X, Website)
 * - Toggle auto-insert on new compose
 */
export default function SignatureEditor({ prefs, onUpdate }) {
    var _a, _b, _c, _d, _e, _f, _g;
    function handleOverride(field, value) {
        onUpdate({
            overrides: Object.assign(Object.assign({}, prefs.overrides), { [field]: value || undefined }),
        });
    }
    return (React.createElement("div", { style: styles.container },
        React.createElement("div", { style: styles.row },
            React.createElement("label", { style: styles.label }, "Template"),
            React.createElement("div", { style: styles.radioGroup }, ["modern", "classic"].map((t) => (React.createElement("label", { key: t, style: styles.radioLabel },
                React.createElement("input", { type: "radio", name: "template", value: t, checked: prefs.template === t, onChange: () => onUpdate({ template: t }), style: styles.radioInput }),
                t.charAt(0).toUpperCase() + t.slice(1)))))),
        React.createElement("div", { style: styles.row },
            React.createElement("label", { style: styles.label }, "Auto-insert on compose"),
            React.createElement("input", { type: "checkbox", checked: prefs.autoInsert, onChange: (e) => onUpdate({ autoInsert: e.target.checked }), style: styles.checkbox })),
        React.createElement("hr", { style: styles.divider }),
        React.createElement("p", { style: styles.overrideHint }, "Leave blank to use your Entra ID profile value."),
        React.createElement(OverrideField, { label: "Mobile override", placeholder: "e.g. +1 555 123 4567", value: (_a = prefs.overrides.mobilePhone) !== null && _a !== void 0 ? _a : "", onChange: (v) => handleOverride("mobilePhone", v) }),
        React.createElement(OverrideField, { label: "Direct phone override", placeholder: "e.g. +1 555 987 6543", value: (_b = prefs.overrides.directPhone) !== null && _b !== void 0 ? _b : "", onChange: (v) => handleOverride("directPhone", v) }),
        React.createElement(OverrideField, { label: "Job title override", placeholder: "e.g. Senior Engineer", value: (_c = prefs.overrides.jobTitle) !== null && _c !== void 0 ? _c : "", onChange: (v) => handleOverride("jobTitle", v) }),
        React.createElement(OverrideField, { label: "Company name override", placeholder: "e.g. Contoso Ltd", value: (_d = prefs.overrides.companyName) !== null && _d !== void 0 ? _d : "", onChange: (v) => handleOverride("companyName", v) }),
        React.createElement("hr", { style: styles.divider }),
        React.createElement("p", { style: styles.overrideHint }, "Optional links (leave blank to omit)"),
        React.createElement(OverrideField, { label: "LinkedIn URL", placeholder: "https://linkedin.com/in/yourname", value: (_e = prefs.linkedInUrl) !== null && _e !== void 0 ? _e : "", onChange: (v) => onUpdate({ linkedInUrl: v || undefined }) }),
        React.createElement(OverrideField, { label: "Twitter / X handle", placeholder: "yourhandle (without @)", value: (_f = prefs.twitterHandle) !== null && _f !== void 0 ? _f : "", onChange: (v) => onUpdate({ twitterHandle: v || undefined }) }),
        React.createElement(OverrideField, { label: "Website URL", placeholder: "https://yourcompany.com", value: (_g = prefs.websiteUrl) !== null && _g !== void 0 ? _g : "", onChange: (v) => onUpdate({ websiteUrl: v || undefined }) })));
}
function OverrideField({ label, placeholder, value, onChange, }) {
    return (React.createElement("div", { style: styles.field },
        React.createElement("label", { style: styles.fieldLabel }, label),
        React.createElement("input", { type: "text", style: styles.input, placeholder: placeholder, value: value, onChange: (e) => onChange(e.target.value) })));
}
const styles = {
    container: {
        backgroundColor: "#ffffff",
        border: "1px solid #d0d0d0",
        borderRadius: 4,
        padding: "12px 14px",
    },
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 10,
    },
    label: {
        fontSize: 13,
        color: "#323130",
        fontWeight: 600,
    },
    radioGroup: {
        display: "flex",
        gap: 12,
    },
    radioLabel: {
        display: "flex",
        alignItems: "center",
        gap: 4,
        fontSize: 13,
        color: "#323130",
        cursor: "pointer",
    },
    radioInput: {
        cursor: "pointer",
    },
    checkbox: {
        cursor: "pointer",
        width: 16,
        height: 16,
    },
    divider: {
        border: "none",
        borderTop: "1px solid #edebe9",
        margin: "10px 0",
    },
    overrideHint: {
        margin: "0 0 8px",
        fontSize: 11,
        color: "#605e5c",
    },
    field: {
        marginBottom: 8,
    },
    fieldLabel: {
        display: "block",
        fontSize: 11,
        color: "#605e5c",
        marginBottom: 3,
    },
    input: {
        width: "100%",
        padding: "5px 8px",
        fontSize: 13,
        border: "1px solid #d0d0d0",
        borderRadius: 3,
        fontFamily: "Arial, sans-serif",
        color: "#323130",
        boxSizing: "border-box",
        outline: "none",
    },
};
